export const CREATE_APPOINTMENT_FOR_USER = "CREATE_APPOINTMENT_FOR_USER";
export const EDIT_APPOINTMENT = "EDIT_APPOINTMENT";
export const CREATE_APPOINTMENT = "CREATE_APPOINTMENT";
export const DELETE_APPOINTMENT = "DELETE_APPOINTMENT";
export const VIEW_APPOINTMENT = "VIEW_APPOINTMENT";

export const DELETE_PET = "DELETE_PET";
export const EDIT_PET = "EDIT_PET";
export const CREATE_PET = "CREATE_PET";
export const CHANGE_PET_OWNER = "CHANGE_PET_OWNER";

export const CREATE_TEMPLATES = "CREATE_TEMPLATES";
export const EDIT_TEMPLATES = "EDIT_TEMPLATES";
export const DELETE_TEMPLATES = "DELETE_TEMPLATES";
export const VIEW_TEMPLATES = "VIEW_TEMPLATES";
export const CREATE_PRESCRIPTION_TEMPLATES = "CREATE_PRESCRIPTION_TEMPLATES";
export const EDIT_PRESCRIPTION_TEMPLATES = "EDIT_PRESCRIPTION_TEMPLATES";
export const DELETE_PRESCRIPTION_TEMPLATES = "DELETE_PRESCRIPTION_TEMPLATES";
export const VIEW_PRESCRIPTION_TEMPLATES = "VIEW_PRESCRIPTION_TEMPLATES";
export const CREATE_REFERRAL_TEMPLATES = "CREATE_REFERRAL_TEMPLATES";
export const EDIT_REFERRAL_TEMPLATES = "EDIT_REFERRAL_TEMPLATES";
export const DELETE_REFERRAL_TEMPLATES = "DELETE_REFERRAL_TEMPLATES";
export const VIEW_REFERRAL_TEMPLATES = "VIEW_REFERRAL_TEMPLATES";
export const CREATE_INSTITUTIONS = "CREATE_INSTITUTIONS";
export const EDIT_INSTITUTIONS = "EDIT_INSTITUTIONS";
export const DELETE_INSTITUTIONS = "DELETE_INSTITUTIONS";
export const VIEW_INSTITUTIONS = "VIEW_INSTITUTIONS";

export const VIEW_PENDING = "VIEW_PENDING";
export const ACCEPT_PENDING = "ACCEPT_PENDING";
export const REJECT_PENDING = "REJECT_PENDING";

export const DOCTORS_LETTER = "DOCTORS_LETTER";

export const VIEW_ADMINISTRATION = "VIEW_ADMINISTRATION";

export const VIEW_SPECIES_ADMINISTRATION = "VIEW_SPECIES_ADMINISTRATION";

export const VIEW_SETTINGS = "VIEW_SETTINGS";

export const EDIT_CLINIC = "EDIT_CLINIC";
export const ADD_EMPLOYEE_TO_CLINIC = "ADD_EMPLOYEE_TO_CLINIC";
export const CHANGE_EMPLOYEE_PERMISSION_IN_CLINIC =
  "EDIT_EMPLOYEE_PERMISSION_IN_CLINIC";
export const CHANGE_CLINIC_EMPLOYEE = "CHANGE_CLINIC_EMPLOYEE";
export const VIEW_CLINIC = "VIEW_CLINIC";

export const CREATE_TREATMENT = "CREATE_TREATMENT";
export const EDIT_TREATMENT = "EDIT_TREATMENT";

export const CREATE_PRICE = "CREATE_SERVICE";
export const DELETE_PRICE = "DELETE_SERVICE";
export const EDIT_PRICE = "EDIT_SERVICE";

export const MANGAE_WORKING_HOURS = "MANAGE_WORKING_HOURS";

export const VIEW_AUDITING = "VIEW_AUDITING";
export const EDIT_SPECIES_LIST = "EDIT_SPECIES_LIST";

export const EDIT_EMPLOYEE_ACTIVATION_STATUS =
  "EDIT_EMPLOYEE_ACTIVATION_STATUS";
export const EDIT_CLIENT_ACTIVATION_STATUS = "EDIT_CLIENT_ACTIVATION_STATUS";
export const EDIT_CATEGORIES = "EDIT_CATEGORIES";

export const ADD_CUSTOM_INFORMATION_FIELD = "ADD_CUSTOM_INFORMATION_FIELD";
export const EDIT_CUSTOM_INFORMATION_FIELD = "EDIT_CUSTOM_INFORMATION_FIELD";
export const DELETE_CUSTOM_INFORMATION_FIELD =
  "DELETE_CUSTOM_INFORMATION_FIELD";

export const VIEW_INBOX = "VIEW_INBOX";
export const SEND_INBOX = "SEND_INBOX";

export const ADD_DOCUMENTS = "ADD_DOCUMENTS";
export const DELETE_DOCUMENTS = "DELETE_DOCUMENTS";
export const VIEW_USER_ADMINISTRATION = "VIEW_USER_ADMINISTRATION";

export const VIEW_SERVICES = "VIEW_SERVICES";
export const CREATE_DOCTORS_LETTER = "CREATE_DOCTORS_LETTER";
export const UPLOAD_LOGO = "UPLOAD_LOGO";
export const UPLOAD_ABOUT_US = "UPLOAD_ABOUT_US";
export const ADD_PROFILE_PICTURE = "ADD_PROFILE_PICTURE";
export const VIEW_DOCUMENT_CATEGORIES = "VIEW_DOCUMENT_CATEGORIES";
export const ADD_DOCUMENT_CATEGORIES = "ADD_DOCUMENT_CATEGORIES";
export const VIEW_WAREHOUSE = "VIEW_WAREHOUSE";
export const ADD_WAREHOUSE_ITEM = "ADD_WAREHOUSE_ITEM";
export const DELETE_WAREHOUSE_ITEM = "DELETE_WAREHOUSE_ITEM";
export const EDIT_WAREHOUSE_ITEM = "EDIT_WAREHOUSE_ITEM";
export const VIEW_LOGO_UPLOAD = "VIEW_LOGO_UPLOAD";
export const VIEW_CUSTOM_INFORMATION_FIELD = "VIEW_CUSTOM_INFORMATION_FIELD";
export const VIEW_STATIONARY = "VIEW_STATIONARY";
